import { Button, Modal } from 'components/core';
import { Styled } from '.';
import { useI18n } from 'contexts/i18n';

export const TermsConditionsAcceptedModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const i18n = useI18n();
  return (
    <Modal>
      <Styled.AccpetedTCContainer>
        {i18n['Your contract has been successfully signed. One of our sales representatives will be in touch with you shortly.']}
        <br />
        <br />
        <Button onClick={onClose}>{i18n['Close']}</Button>
      </Styled.AccpetedTCContainer>
    </Modal>
  );
};
